module.exports = __webpack_public_path__ + "static/media/overview_supporting@2x.4ac3a1cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/footage/others/overview_supporting@2x.png
// module id = 568
// module chunks = 0